import React, { Component } from "react";
import "./achievement.css";
import { Container } from "react-bootstrap";

export default class Achievement extends Component {
  render() {
    return (
      <>
        <Container className="achievement">
          {/* <Particle /> */}
          <div className="first">
            <p className="tag">
              Watch my <span className="purple">DSA</span> Mock Interview with
              GeeksForGeeks
            </p>
            <iframe
              className="frame"
              src="https://www.youtube.com/embed/oIJyKS1raPI"
              title="YouTube video player"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        </Container>
        <Container className="achievement">
          {/* <Particle /> */}
          <div className="first">
            <p className="tag">
              Checkout demo of the project that i did in Google Summer of Code (GSoC's) under the <a href='https://www.rocket.chat/' className="purple">Rocket.Chat</a> .
            </p>
           
            <iframe
              className="frame"
              src="https://www.youtube.com/embed/CMtyC1UlZ80"
              title="YouTube video player"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        </Container>
      </>
    );
  }
}
